export default "__VITE_ASSET__BMXRVdu9__"